// hooks/property/useUserListing.js
import { useState, useEffect, useCallback } from "react";
import { getPropertiesById } from "../../../services/propertyService";

export const useUserListing = (id) => {
  const [cars, setCars] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({
    brand: "",
    model: "",
    year: "",
    isSold: false,
  });

  const limit = 6;

  const fetchCars = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getPropertiesById(id, filters, page, limit);
      setCars(data.cars);
      setPagination(data.pagination);
    } catch (err) {
      setError(err?.message || "Có lỗi xảy ra khi tải dữ liệu.");
    } finally {
      setLoading(false);
    }
  }, [id, page, filters]);

  useEffect(() => {
    if (id) fetchCars();
  }, [fetchCars, id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
    setPage(1);
  };

  return {
    cars,
    pagination,
    loading,
    error,
    page,
    setPage,
    filters,
    handleInputChange,
  };
};